import React, { useState, useEffect } from 'react'
import { Col, Icon, IconButton, Panel, Row } from 'rsuite'
import { startLoading, doneLoading } from './../../utils/loading'
import notification from './../../utils/notification'
import { DEFAULT_ERR_MSG } from './../../constants/msgText'
import { cloneDeep } from 'lodash'
import {
  searchAssetQrCodeReportPage,
  PostDownloadAssetQrCodeReportPage,
} from './../../redux/actions/addDurableArticles'
import { downloadFile } from './../../utils/fileUtil'
import SearchFormExpertPayment from './SearchFormExpertPayment'
import ExpertPaymentListTable from './ExpertPaymentListTable'
import { searchExpertPayment } from '../../redux/actions/searchExpertPayment'

export default function SearchExpertPaymentWidget(props) {
  const { projectCode } = props

  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [displayLength, setDisplayLength] = useState(5)
  const [page, setPage] = useState(1)
  const [searchRequest, setSearchRequest] = useState({})

  // console.log('formSchema ', formSchema)

  const handleSearch = async (request, pagenumber, pagesize) => {
    setIsLoading(true)
    startLoading()
    try {
      console.log('testHandleSearch', request, pagenumber, pagesize)
      setPage(pagenumber)
      setDisplayLength(pagesize)
      setSearchRequest(request)

      const response = await searchExpertPayment(request, pagenumber, pagesize)
      // console.log('response ', response)
      if (response) {
        let _schema = cloneDeep(formSchema)

        _schema.result = response.model
        setFormSchema(_schema)
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('error', e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const onReload = (pagenumber, pagesize) => {
    console.log('5555', pagenumber, pagesize, searchRequest)
    // setPage(pagenumber)
    // setDisplayLength(pagesize)
    handleSearch(searchRequest, pagenumber, pagesize)
  }

  const onSearch = (request) => {
    handleSearch(request, 1, displayLength)
  }

  return (
    <>
      <Panel shaded defaultExpanded header={formSchema?.header || ' '} bordered>
        {formSchema?.searchForm && (
          <div style={{ marginTop: 0 }}>
            <SearchFormExpertPayment
              schema={formSchema.searchForm}
              onSearch={onSearch}
              loading={isLoading}
            />
          </div>
        )}

        <ExpertPaymentListTable
          schema={formSchema?.result}
          loading={isLoading}
          onReload={onReload}
          page={page}
          displayLength={displayLength}
        />
      </Panel>
    </>
  )
}
